import { render, staticRenderFns } from "./ExampleSpecies.vue?vue&type=template&id=604366b4&"
import script from "./ExampleSpecies.vue?vue&type=script&lang=js&"
export * from "./ExampleSpecies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports